{
  "name": "sites-builder-app",
  "version": "1.5.1",
  "scripts": {
    "ng": "ng",
    "dev": "ng serve --configuration development --ssl",
    "dev:mobile": "ng serve --host 0.0.0.0 --allowed-hosts local.3ddigitalvenue.com --public-host local.3ddigitalvenue.com --configuration development",
    "start": "ng serve --host local.3ddigitalvenue.com --open --ssl true",
    "start:local": "ng serve --host local.3ddigitalvenue.com --configuration local --open --ssl true",
    "start:prod": "ng serve --host local.3ddigitalvenue.com --configuration production --open --ssl true",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:pre": "ng build --configuration preproduction",
    "build:prod": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@3ddv/dvm-internal": "^2.7.7",
    "@3ddv/ngx-dvm-internal": "^4.2.6",
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@floating-ui/dom": "^1.6.13",
    "@splidejs/splide": "^4.1.4",
    "@tailwindcss/postcss": "^4.0.6",
    "@tiptap/core": "^3.7.2",
    "@tiptap/extension-heading": "^3.7.2",
    "@tiptap/starter-kit": "^3.7.2",
    "animejs": "^3.2.2",
    "lodash-es": "^4.17.21",
    "postcss": "^8.5.2",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.0.6",
    "tslib": "^2.3.0",
    "zod": "^3.24.3",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.12",
    "@angular/cli": "^18.2.12",
    "@angular/compiler-cli": "^18.2.0",
    "@types/animejs": "^3.1.13",
    "@types/jasmine": "~5.1.0",
    "@types/lodash-es": "^4.17.12",
    "angular-eslint": "19.3.0",
    "eslint": "^9.23.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "schematics": "file:schematics",
    "typescript": "~5.5.2",
    "typescript-eslint": "8.27.0"
  },
  "overrides": {
    "@angular-devkit/build-angular": {
      "tailwindcss": "^4.0.6"
    }
  }
}
